
import Model from './model';

export default class User extends Model {
  static fields = [
    { name: 'id', default: 0 },
    { name: 'slug', default: '' },
    { name: 'name', default: '' },
    { name: 'about', default: '' },
    { name: 'admin', default: false },
    { name: 'author', default: false },
    { name: 'country', default: '' },
    { name: 'dob', default: '' },
    { name: 'email', default: '' },
    { name: 'gender', default: '' },
    { name: 'image', default: '' },
    { name: 'latitude', default: '' },
    { name: 'longitude', default: '' },
    { name: 'occupation', default: '' },
    { name: 'postcode', default: '' },
    { name: 'website', default: '' },
    { name: 'plays', default: 0 },
    'stats'
  ];
}
